import _get from 'lodash/get';

export default function hydrateVMessages(Exception) {
  let message = null;
  try {
    let vMessages = _get(Exception, 'response.data.message');

    if (vMessages) {
      message = vMessages;
    }
  } catch (e) {}
  return message;
}
